import { useMutation } from "@apollo/client";
import { useCallback, useState } from "react";

import { GqlPlannerV2FieldworkerRemovePickupDropoffLocationInput } from "~/__generated__/graphql/types";

import { PlannerV2FieldworkerRemovePickupDropoffLocationDocument } from "../mutations.generated";
import { PlannerV2TravelGroupGetTimelineDocument } from "../queries.generated";

export default function usePlannerV2FieldworkerRemovePickupDropoffLocation(onSuccess: (plannerTravelGroupId: string) => void) {
    const [loadingToRemoveShiftId, setLoadingToRemoveShiftId] = useState<string | null>(null);
    const [mutate, { data, loading, error }] = useMutation(PlannerV2FieldworkerRemovePickupDropoffLocationDocument, {
        refetchQueries: [PlannerV2TravelGroupGetTimelineDocument],
        awaitRefetchQueries: true,
    });

    const removePickupPoint = useCallback(
        async (input: GqlPlannerV2FieldworkerRemovePickupDropoffLocationInput) => {
            setLoadingToRemoveShiftId(input.plannerShiftId);
            try {
                const response = await mutate({
                    variables: { input },
                });
                const plannerTravelGroupId = response.data?.plannerV2FieldworkerRemovePickupDropoffLocation?.id;
                if (plannerTravelGroupId) onSuccess(plannerTravelGroupId);
            } finally {
                setLoadingToRemoveShiftId(null);
            }
        },
        [mutate, onSuccess],
    );

    return {
        removePickupPoint,
        loading,
        loadingToRemoveShiftId,
        error,
        data,
    };
}
